import * as React from "react";
const SvgIconValue = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 14v14H4V14h6zm9-4v18h-6V10h6zm9-5v23h-6V5h6z", fill: "#b1bac6", fillRule: "evenodd" }));
export default SvgIconValue;
